module.exports = __webpack_public_path__ + "img/qualification_4.a8c2ecd8.png";